import client from 'utils/client';

const SizesSelectionsMiddleware = store => next => action => {
  if (action.type === 'POST_SIZES') {
    const postArr = [];
    for (let i = 0; i < action.sizes.length; i++) {
      if (action.sizes[i].amount > 0) {
        const foundIndex = postArr.findIndex(
          el =>
            el.subgroup_id === action.sizes[i].subgroupID &&
            el.id === action.sizes[i].productID
        );

        if (foundIndex >= 0) {
          postArr[foundIndex].sizes.push({
            quantity: parseInt(action.sizes[i].amount, 10),
            id: action.sizes[i].sizeID
          });
        } else {
          postArr.push({
            choices_id: action.sizes[i].choicesID,
            subgroup_id: action.sizes[i].subgroupID,
            id: action.sizes[i].productID,
            sizes: [
              {
                quantity: parseInt(action.sizes[i].amount, 10),
                id: action.sizes[i].sizeID
              }
            ]
          });
        }
      }
    }

    const postObj = { products: postArr };
    client
      .post('/services/product_groups/select_quantities/', postObj)
      .then(() => {
        client
          .get(`/services/get_selection/?is_customization=${true}`)
          .then(resp => {
            store.dispatch({
              type: 'RECIEVE_CUSTOMIZATION',
              costumizations: resp.data.subgroups
            });
            store.dispatch({
              type: 'CALCULATE_CUSTOMIZATION_SELECTION',
              customizations: store.getState().customizations,
              customizationItems: store.getState().customizationItems,
              costumizationToggleItems:
                store.getState().costumizationToggleItems
            });
          });
      });
  }

  if (action.type === 'UPDATES_SIZE_SELECTION') {
    store.dispatch({
      type: 'SIZE_SELECTION',
      amount: action.amount,
      sizeID: action.sizeID,
      productID: action.productID,
      choicesID: action.choicesID,
      inStock: action.inStock,
      subgroupID: action.subgroupID
    });
    store.dispatch({
      type: 'CALCULATE_AMOUT_SELECTION',
      sizes: store.getState().sizes,
      sizeSelections: store.getState().sizeSelection
    });
    store.dispatch({
      type: 'SIZE_CAN_CONTINUE',
      sizeSelections: store.getState().sizeSelection
    });
  }
  next(action);
};

export default SizesSelectionsMiddleware;
